import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrivateService } from 'app/core/services/private.service';

@Component({
  selector: 'dialog-employee-delete',
  templateUrl: './dialog-employee-delete.component.html',
  styleUrls: ['./dialog-employee-delete.component.scss']
})
export class DialogEmployeeDeleteComponent implements OnInit {

  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogEmployeeDeleteComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private privateService: PrivateService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteEmployee() {
    this.isLoading = true;
    this.privateService.deleteEmployee(this.data.C_BPartner_ID).subscribe({
      next: res => {
        this.dialogRef.close();
        window.location.reload();
        this.isLoading = false;
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    })
  }
}
